<script lang="ts">
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Mousewheel } from "swiper";
  import "swiper/css";
  import optimizeImage, { aspectRatio } from "$lib/utils/optimizeImage";

  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";
  import { modalContent, modalIsOpened, modalStartIndex } from "$stores";

  function onCardClick(index) {
    $modalStartIndex = index;
    $modalContent = posts[index]?.content?.videoFields?.modal[0];
    $modalIsOpened = true;
  }

  export let posts: any;

  let slider;
  $: isBeginning = true;
  $: isEnd = false;

  function swiperReady(e) {
    slider = e.detail[0];
  }

  function slidePrev() {
    slider.slidePrev();
  }

  function slideNext() {
    slider.slideNext();
  }
</script>

{#if posts}
  <div class="max-w-[100vw] overflow-visible">
    <Swiper
      on:swiper={swiperReady}
      on:progress={async (e) => {
        isBeginning = slider?.isBeginning;
        isEnd = slider?.isEnd;
      }}
      navigation
      breakpoints={{
        0: {
          slidesPerView: 1.15,
        },
        768: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 2,
        },
      }}
      modules={[Mousewheel]}
      mousewheel={{
        releaseOnEdges: true,
        forceToAxis: true,
      }}
      spaceBetween={24}
      slidesPerView={3}
      preventClicks={false}
      preventClicksPropagation={true}
      shortSwipes={false}
      longSwipesRatio={0.2}
      longSwipesMs={20}
      class="!overflow-visible"
    >
      {#each posts as post, index}
        <SwiperSlide>
          <div
            class="flex aspect-[588/346] relative overflow-hidden items-end rounded-md p-5 sm:p-7 lg:p-8 cursor-pointer bg-white/20 group"
            role="button"
            tabindex="0"
            on:click={() => onCardClick(index)}
            on:keydown={() => {}}
          >
            <div
              class="pointer-events-none absolute inset-0 bg-gradient-to-t lg:top-[20%] {post
                ?.content?.videoFields?.modalPreviewTextColor === 'text-white'
                ? 'from-[rgba(0,0,0,.9)]'
                : 'from-[rgba(255,255,255,.5)]'} to-transparent z-10"
            />

            {#if post?.content?.mastheadImage?.filename}
              <img
                src={optimizeImage(post.content.mastheadImage.filename)}
                alt={post?.content?.mastheadImage?.alt}
                class="absolute inset-0 object-cover object-center w-full h-full group-hover:scale-[1.02] scale-100 transition-transform duration-300"
                style={aspectRatio(post.content.mastheadImage.filename)}
                loading="lazy"
              />
            {/if}

            <div class="absolute inset-0 flex items-center justify-center">
              <svg
                class="pb-[3%] flex-[0_0_auto] w-[15%] lg:w-[12%] min-w-[55px] max-w-[75px] h-full relative z-10"
                viewBox="0 0 76 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><rect
                  x=".176"
                  y=".5"
                  width="75.171"
                  height="43"
                  rx="6"
                  fill="#fff"
                /><path
                  d="M32.685 29a.95.95 0 0 1-.653-.256.852.852 0 0 1-.27-.619v-12.25a.84.84 0 0 1 .128-.445.903.903 0 0 1 .35-.322.964.964 0 0 1 .94.029l10.154 6.125c.131.079.24.188.314.317a.84.84 0 0 1 0 .843.896.896 0 0 1-.314.317l-10.153 6.124a.96.96 0 0 1-.496.137z"
                  fill="#212121"
                /></svg
              >
            </div>

            <div class="flex-auto relative z-10">
              <h6 class="type:eyebrow uppercase !text-white mb-2 opacity-50">
                {post?.category_name}
              </h6>

              <div class="flex items-center justify-between gap-[.75rem]">
                <h3
                  class={`type:h6-large relative z-10 line-clamp-2 lg:max-w-[70%] xl:max-w-[58%] ${post?.content?.videoFields?.modalPreviewTextColor}`}
                >
                  {@html post?.name}
                </h3>
                <div class="!text-white type:body-medium">
                  {post?.content?.mediaLength || ""}
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      {/each}
    </Swiper>

    <div
      class="flex gap-2.5 justify-end mt-[35px] sm:absolute top-0 right-0 sm:mt-[0] md:mt-[5px] lg:mt-[8px]"
    >
      <div
        class="transition-opacity duration-150"
        style={`${isBeginning ? "opacity:0.3;pointer-events:none;" : ""}`}
      >
        <Button
          icon={IconType.ARROW_LEFT_LARGE}
          color={ButtonColor.GRAY}
          reduced
          on:click={slidePrev}
          iconLeft={false}
        />
      </div>
      <div
        class="transition-opacity duration-150"
        style={`${isEnd ? "opacity:0.3;pointer-events:none;" : ""}`}
      >
        <Button
          icon={IconType.ARROW_RIGHT_LARGE}
          color={ButtonColor.GRAY}
          reduced
          on:click={slideNext}
        />
      </div>
    </div>
  </div>
{/if}
